export default __webpack_public_path__ + "static/media/logo-talk.781eda9d.png";